import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { map, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NetworkError } from 'shared/models/network-error';
import { ErrorReportingService } from 'core/services/error-reporting.service';

const IGNORED_SENTRY_HTTP_STATUSES = new Set([401, 403]);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private _errorReportingService: ErrorReportingService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((response: HttpEvent<any>) => {
        const successCodes: number[] = [200, 201, 204];
        if (response instanceof HttpResponse && !successCodes.includes(response.status)) {
          throw new HttpErrorResponse(response);
        }
        return response;
      }),
      catchError((err: HttpErrorResponse) => {
        const errorCode: number = err?.status;
        const errorDescription: string = err?.statusText;
        const networkError: NetworkError = new NetworkError(errorCode, errorDescription, err?.error);

        if (!this.isIgnoredSentryStatus(errorCode)) {
          this._errorReportingService.captureHttpError(networkError, request);
        }

        return throwError(() => networkError);
      })
    );
  }

  private isIgnoredSentryStatus(status: number): boolean {
    return IGNORED_SENTRY_HTTP_STATUSES.has(status);
  }
}
